/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Shim for allowing custom element button types to be wrapped with anchors as Safari prevents use of extending native element types.
 * Will detect presence of anchor and set component to a readonly button state.
 *
 * Example:
 *
 * ```html
 * <a href="#">
 *  <cds-button></cds-button>
 * </a>
 * ```
 */
export function buttonAnchor() {
    return (target) => target.addInitializer((instance) => new ButtonAnchorController(instance));
}
export class ButtonAnchorController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    get currentAnchor() {
        return this.host.parentElement?.tagName === 'A' ? this.host.parentElement : null;
    }
    hostConnected() {
        this.setAnchor();
    }
    hostUpdated() {
        this.setAnchor();
    }
    setAnchor() {
        if (this.currentAnchor && this.currentAnchor !== this.previousAnchor) {
            this.previousAnchor = this.currentAnchor;
            this.host.readonly = true;
            this.currentAnchor.style.lineHeight = '0';
            this.currentAnchor.style.textDecoration = 'none'; // fixes issue when style is applied to text node
        }
    }
}
